import React from 'react'
import PropTypes from 'prop-types'

import { ReactComponent as InconHome } from '../assets/images/home.svg'
import { ReactComponent as InconArrow } from '../assets/images/arrow-left.svg'

const ButtonNavigation = ({navigationButton, handleNavigation}) => {
  return (
    <div className={`button_navigation ${navigationButton.goBack ? 'withBack' : ''}`}>
      {navigationButton.goBack && <button className='back' onClick={() => handleNavigation('back')}>
        <InconArrow />
        <span>Попередня</span>
      </button>}
      {navigationButton.goHome && <button className='home' onClick={() => handleNavigation('home')}>
        <InconHome />
        <span>На головну</span>
      </button>}
    </div>
  )
}

ButtonNavigation.propTypes = {
  navigationButton: PropTypes.shape({
    goBack: PropTypes.bool,
    goHome: PropTypes.bool,
  }),
  handleNavigation: PropTypes.func
}

export default ButtonNavigation